import { render } from "./PlotReceipts.vue?vue&type=template&id=f079511c&scoped=true"
import script from "./PlotReceipts.vue?vue&type=script&lang=js"
export * from "./PlotReceipts.vue?vue&type=script&lang=js"

import "./PlotReceipts.vue?vue&type=style&index=0&id=f079511c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f079511c"]])

export default __exports__